<script setup lang="ts">
import { type BaseButtonProps } from '@/components/buttons/index'
import SpinnerIcon from '@/components/displays/SpinnerIcon.vue'
import { Button } from '@/components/shad/ui/button'

const click = ($event: Event) => emit('click', $event)
const emit = defineEmits<{click: [Event]}>()
const props = defineProps<BaseButtonProps>()
</script>

<template>
  <Button
    v-bind="props"
    :variant="props.variant"
    :class="[
      'flex items-center gap-x-2',
      {
        'drop-shadow-none shadow-inner !brightness-110 !ring-2 !ring-subdued':
          props.selected,
      },
    ]"
    @click="click"
  >
    <div>
      <SpinnerIcon v-if="loading" />
      <div v-else  class="-pl-2.5 flex flex-row items-center justify-between gap-x-2">
        <component :is="props.icon" v-if="props.icon" :size="16" :class="props.iconClass"/>
        <!-- Trimmed to cap height and baseline so the label centers on its letters; a slot holding elements (an icon) drops the span so they stay in the row. -->
        <span class="[text-box:trim-both_cap_alphabetic] has-[>*]:contents"><slot name="default" /></span>
      </div>
    </div>
  </Button>
</template>

<style scoped></style>
